import { useCallback, useState } from 'react';
import {
  getCurrentResortData,
  getResortLocationUrl,
  getResortShortName,
  updateCurrentResortData
} from '../../utilities/resortLocation';

export default function useCurrentResort() {
  const resortLocationUrl = getResortLocationUrl(); //e.g. "/wisconsin-dells/"
  const resortShortName = getResortShortName(); //e.g. "wisconsin-dells"

  const [{ resortDisplay, resortPhone, resortAddress }, setResortData] = useState(getCurrentResortData());

  const updateResortData = useCallback(locationList => {
    const dataToStore = updateCurrentResortData(locationList);
    setResortData(dataToStore);
  }, []);

  return {
    resortLocationUrl,
    resortShortName,
    resortDisplay,
    resortPhone,
    resortAddress,
    updateResortData
  };
}
